export function LocationLoader() {
	return (
		<div className="absolute inset-0 flex items-center justify-center bg-tertiary">
			<div className="text-center">
				<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-current text-selection mx-auto mb-2" />
				<p className="text-secondary">Loading map...</p>
			</div>
		</div>
	);
}
